import { SERVER_URL } from "../ServerUrl";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
// Common
import { Alert } from "../admin/common/Alert";
import {
  EXCLUSIVE_TRIPS_LOADED,
  REGULAR_TRIPS_LOADED,
  ADD_TRIP_SUCCESS,
  ADD_TRIP_FAIL,
  UPDATE_TRIP_FAIL,
  UPDATE_TRIP_SUCCESS,
  DELETE_TRIP_FAIL,
  DELETE_TRIP_SUCCESS,
  ALL_TRIPS_LOADED,
  TRIP_LOADED,
  RETURN_TRIPS_LOADED,
  DEPARTURE_TRIPS_LOADED,
  ADD_PACKAGE_SUCCESS,
  EXCLUSIVE_PACKAGES_LOADED,
  REGULAR_PACKAGES_LOADED,
  DEPARTURE_PACKAGES_LOADED,
  ALL_PACKAGES_LOADED,
  OPERATORS_TRIPSPACKAGES_LOADED,
  ALL_COMMISIONS_LOADED,
  OPERATORS_COMMISIONS_LOADED,
  OPERATOR_UPDATENEW_SUCCESS,
} from "./types";
import setAuthToken from "../admin/utils/setAuthToken";
const cookies = new Cookies();

export const getAllTrips = () => async (dispatch) => {
  try {
    const res = await axios.get(`${SERVER_URL}/trip/`);

    dispatch({
      type: ALL_TRIPS_LOADED,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getAllPackages = () => async (dispatch) => {
  try {
    const res = await axios.get(`${SERVER_URL}/package/active-packages`);
    dispatch({
      type: ALL_PACKAGES_LOADED,
      payload: res?.data?.packages,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getDepartureTrips = (departureTripsdata) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${SERVER_URL}/trip/filter-trips`,
      {
        from: departureTripsdata.from,
        to: departureTripsdata.to,
        date: departureTripsdata.date,
      },
      { headers: { "Content-Type": "application/json" } }
    );

    dispatch({
      type: DEPARTURE_TRIPS_LOADED,
      payload: res?.data?.trips,
    });
  } catch (error) {
    console.log("API Error:", error);
  }
};

export const getReturnTrips = (returnTripsdata) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${SERVER_URL}/trip/filter-trips`,
      {
        from: returnTripsdata.from,
        to: returnTripsdata.to,
        date: returnTripsdata.date,
      },
      { headers: { "Content-Type": "application/json" } }
    );
    dispatch({
      type: RETURN_TRIPS_LOADED,
      payload: res?.data?.trips,
    });
  } catch (error) {
    console.log("API Error:", error);
  }
};

export const getTripById = (tripId) => async (dispatch) => {
  try {
    const res = await axios.get(`${SERVER_URL}/trip/${tripId}`);

    dispatch({
      type: TRIP_LOADED,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getExclusiveTrips = () => async (dispatch) => {
  try {
    const res = await axios.get(`${SERVER_URL}/trip/exclusive-trips`);

    dispatch({
      type: EXCLUSIVE_TRIPS_LOADED,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getRegularTrips = () => async (dispatch) => {
  try {
    const res = await axios.get(`${SERVER_URL}/trip/regular-trips`);

    dispatch({
      type: REGULAR_TRIPS_LOADED,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    Alert("error", "Regular Trips not loaded");
  }
};

// Add trip
export const addTrip = (obj) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }

  const body = JSON.stringify(obj);

  try {
    const res = await axios.post(`${SERVER_URL}/trip/`, body, config);

    dispatch({
      type: ADD_TRIP_SUCCESS,
      payload: res.data,
    });

    Alert("success", "Trip added");
    return { success: true, data: res.data };
  } catch (error) {
    dispatch({
      type: ADD_TRIP_FAIL,
    });
    console.log(error, "45error45");
    Alert("error", "Trip not added");
  }
};

// Update trip
export const updateTrip =
  ({ tripData, ID }) =>
  async (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (sessionStorage.token) {
      setAuthToken(sessionStorage.token);
    }
    console.log(tripData, "97body9879");
    try {
      const res = await axios.patch(
        `${SERVER_URL}/trip/${ID}`,
        tripData,
        config
      );

      dispatch({
        type: UPDATE_TRIP_SUCCESS,
        payload: res.data,
      });
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "The trip has been updated successfully.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_TRIP_FAIL,
      });

      Alert("error", "Trip not updated");
    }
  };

export const updatePackage =
  ({ packageData, ID }) =>
  async (dispatch) => {
    console.log(packageData, "97body9879", ID);
    try {
      const res = await axios.put(
        `${SERVER_URL}/package/packages/${ID}`,
        packageData
      );
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "The package has been updated successfully.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      Alert("error", "Package not updated");
    }
  };

// Delete trip
export const deleteTrip = (id) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }

  try {
    const res = await axios.delete(`${SERVER_URL}/trip/${id}`, config);

    dispatch({
      type: DELETE_TRIP_SUCCESS,
      payload: res.data,
    });

    Swal.fire({
      icon: "success",
      title: "Deleted!",
      text: "The trip has been deleted successfully.",
      timer: 1500,
      showConfirmButton: false,
    });
  } catch (error) {
    dispatch({
      type: DELETE_TRIP_FAIL,
    });

    Alert("error", "Trip deleted");
  }
};

// Delete trip
export const deletePackage = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`${SERVER_URL}/package/packages/${id}`);

    Swal.fire({
      icon: "success",
      title: "Deleted!",
      text: "The Package has been deleted successfully.",
      timer: 1500,
      showConfirmButton: false,
    });
    return { success: true };
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "Something went wrong",
    });
    return { success: false };
  }
};

export const getExclusivePackages = () => async (dispatch) => {
  try {
    const res = await axios.get(`${SERVER_URL}/package/exclusive-packages`);

    dispatch({
      type: EXCLUSIVE_PACKAGES_LOADED,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    // Alert("error", "Exclusive Trips not loaded");
  }
};

export const getRegularPackages = () => async (dispatch) => {
  try {
    const res = await axios.get(`${SERVER_URL}/package/regular-packages`);

    dispatch({
      type: REGULAR_PACKAGES_LOADED,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    // Alert("error", "Regular Trips not loaded");
  }
};

export const getPackages = (departureTripsdata) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${SERVER_URL}/package/filter-packages`,
      {
        from: departureTripsdata.from,
        to: departureTripsdata.to,
        date: departureTripsdata.departureDate,
        packageType: departureTripsdata.tripType,
      },
      { headers: { "Content-Type": "application/json" } }
    );
    dispatch({
      type: DEPARTURE_PACKAGES_LOADED,
      payload: res?.data?.packages,
    });
  } catch (error) {
    console.log("API Error:", error);
  }
};

export const OperatorsPackagesTrips = (operatorId) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${SERVER_URL}/trip/trips-packages-by-operator`,
      { operatorId: operatorId }
    );
    console.log(res?.data?.data, "datapack");
    dispatch({
      type: OPERATORS_TRIPSPACKAGES_LOADED,
      payload: res?.data?.data,
    });
  } catch (error) {
    console.log("API Error:", error);
  }
};

export const PostCommission = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`${SERVER_URL}/commissions`, formData);
    Swal.fire({
      icon: "success",
      title: "success!",
      text: res?.data?.message,
      timer: 1500,
      showConfirmButton: false,
    });
    console.log(res?.data, "datapack");
    return { success: true };
  } catch (error) {
    console.log("API Error:", error);
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "Something went wrong",
    });
    return { success: false };
  }
};

export const getAllCommissions = () => async (dispatch) => {
  try {
    const res = await axios.get(`${SERVER_URL}/commissions`);

    dispatch({
      type: ALL_COMMISIONS_LOADED,
      payload: res?.data?.data,
    });
  } catch (error) {
    console.log(error);
    // Alert("error", "Regular Trips not loaded");
  }
};

export const getOperatorCommissions = (operatorId) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${SERVER_URL}/commissions/operatorCommissions/${operatorId}`
    );
    dispatch({
      type: OPERATOR_UPDATENEW_SUCCESS,
      payload: res?.data?.data?.operatorId,
    });
    dispatch({
      type: OPERATORS_COMMISIONS_LOADED,
      payload: res?.data?.data,
    });
  } catch (error) {
    console.log(error);
    // Alert("error", "Regular Trips not loaded");
  }
};

export const handleCommission = (data) => async (dispatch) => {
  try {
    const res = await axios.put(
      `${SERVER_URL}/commissions/handleCommission`,
      data
    );
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: res?.data?.message,
      // showConfirmButton: false,
    });
    console.log(res?.data?.message, "datapack");
    return { success: true };
  } catch (error) {
    console.log("API Error:", error);
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "Something went wrong",
    });
    return { success: false };
  }
};

export const CommissionDelete = (CancelData) => async (dispatch) => {
  try {
    const res = await axios.delete(
      `${SERVER_URL}/commissions/${CancelData?.operatorId}/history/${CancelData?.historyId}`
    );
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: res?.data?.message,
      // showConfirmButton: false,
    });
    console.log(res?.data?.message, "datapack");
    return { success: true };
  } catch (error) {
    console.log("API Error:", error);
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: error?.data?.message,
    });
    return { success: false };
  }
};

export const EditCommission = (formData, id) => async (dispatch) => {
  try {
    const res = await axios.put(
      `${SERVER_URL}/commissions/${formData?.operatorId}/${id}/edit`,
      formData
    );
    Swal.fire({
      icon: "success",
      title: "success!",
      text: res?.data?.message,
      timer: 1500,
      showConfirmButton: false,
    });
    console.log(res?.data, "datapack");
    return { success: true };
  } catch (error) {
    console.log("API Error:", error);
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "Something went wrong",
    });
    return { success: false };
  }
};
